import { useContext } from "react";
import { BroadcastChatsContext } from "hhn-commons";
import BroadcastChatList from "./BroadcastChatList";
import { BroadcastChatsWrapper } from "./BroadcastChats.styles";

const BroadcastChats = ({ selectedChatId }: { selectedChatId?: string }) => {
  const { chatData, fetchChats, isChatLoading } = useContext(
    BroadcastChatsContext,
  );

  return (
    <BroadcastChatsWrapper>
      <BroadcastChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
      />
    </BroadcastChatsWrapper>
  );
};
export default BroadcastChats;
